export const NAME = "user/impersonate";

export interface ImpersonateState {
    unsuccessfulReason: string;
}

export const initialState: ImpersonateState = {
    unsuccessfulReason: null,
};
